import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { analyticsAllowedOn, initAnalytics } from '@/lib/analytics';
import '@/index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

async function start() {
  // Back the SPA with an in-browser mock when VITE_USE_MOCK=1, so the real UI is
  // drivable without a backend (local dev demo, and the hosted look-and-feel
  // demo build). Statically dead-code-eliminated from normal builds, where
  // VITE_USE_MOCK is unset (Vite inlines import.meta.env.VITE_USE_MOCK at build
  // time, so the branch and the dynamic import are dropped).
  if (import.meta.env.VITE_USE_MOCK === '1') {
    const { installMockApi } = await import('@/mocks/install');
    installMockApi();
  }

  // Never on the keys console or the unlock page (ADR-0069 W12).
  if (analyticsAllowedOn(window.location.pathname)) initAnalytics();
  createRoot(rootElement!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void start();
